import FormInput from './form-input'

const JudgesItem = ({judge, name, index, onValueChange}) => {
    const {uid, c1_locked, c2_locked, c3_locked, top5_locked, top10_locked} = judge;

    return (
        <div className="column is-4">
            <div className="card">
                <div className="card-content">
                    <div className="media">
                        <div className="media-content">
                            <p className="title is-size-3">{uid.toUpperCase()}</p>
                            <label className="checkbox is-block">
                                <input type="checkbox" className='mr-2' checked={c1_locked}/>
                                Festival Costume
                            </label>
                            <label className="checkbox is-block">
                                <input type="checkbox" className='mr-2' checked={c2_locked}/>
                                Production Number
                            </label>
                            <label className="checkbox is-block">
                                <input type="checkbox" className='mr-2' checked={c3_locked}/>
                                Long Gown Competition
                            </label>


                            <label className="checkbox is-block">
                                <input type="checkbox" className='mr-2' checked={top10_locked}/>
                                Top 10
                            </label>
                            
                            <label className="checkbox is-block">
                                <input type="checkbox" className='mr-2' checked={top5_locked}/>
                                Top 5
                            </label>
                            <FormInput additionalClasses="mt-5 mb-3" type="text" required id={index} value={name} onChange={(e) => {onValueChange(e)}} label="Full Name"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default JudgesItem;